import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import OdometerPhotoExplanation from "./OdometerPhotoExplanation";

const landingId = "CF_ODOMETER_PHOTO_EXPLANATION";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <OdometerPhotoExplanation state={state} setState={setState} />
);

const nextPage = async (props) =>
  `/formulario/cancelacion/confianza?uid=${props.uid}`;
const prevPage = (props) => `/formulario/cancelacion/no-gusto?uid=${props.uid}`;

const fieldsStructure = [];

const odometerPhotoExplanationProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default odometerPhotoExplanationProps;
